(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tf-video-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tf-video-categories')) {
    customElements.define('tf-video-categories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tf-filters');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('.tf-category-arrow');
          if (!button || button.disabled) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: Number(button.dataset.direction) * direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
        const revealCurrent = () => {
          if (!this.isConnected) return;
          const active = this.track.querySelector('[aria-current="page"]');
          if (active) {
            const item = active.getBoundingClientRect(), track = this.track.getBoundingClientRect();
            if (item.left < track.left) this.track.scrollBy({ left: item.left - track.left, behavior: 'auto' });
            else if (item.right > track.right) this.track.scrollBy({ left: item.right - track.right, behavior: 'auto' });
          }
          this.update();
        };
        if (document.fonts) document.fonts.ready.then(revealCurrent);
        else revealCurrent();
      }
      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const position = Math.max(0, Math.min(max, this.track.scrollLeft * direction));
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
      }
      disconnectedCallback() { this.abort.abort(); this.resize.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
